import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function JumpSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="rounded-2xl border border-background-200 bg-background-100 p-8 text-center md:p-12">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("jump.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-foreground-600">
            {t("jump.subtitle")}
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              {t("jump.primary")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap cursor-pointer"
            >
              {t("jump.secondary")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}